import { flow, initial, last, mapKeys } from "lodash";
import { home } from "./guards/home";

/**
 * For every folder in 'pages' match the file named as the folder eg pages/Wizard/Wizard.vue
 * The rest of the files are used in the page but need not be made available
 *
 * \\1 is equivalent to \1 in regex, matches the capturing group number 1
 */
const modules = import.meta.glob("@/pages/**/*.vue");
// Takes a path and returns a capitalized module name
const getModuleName = flow([
  (value, key) => key.split(/[/.]+/g),
  initial,
  last,
]);

// Makes a map of all the pages in the application
const pages = mapKeys(modules, getModuleName);

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
  },
  {
    path: '/home',
    name: 'home',
    redirect: home, // authenticated → my-services, guest → public-home
    meta: {
      alwaysAvailable: true
    }
  },
  {
    path: '/public-home',
    name: 'public-home',
    component: () => import('@/pages/PublicHome/PublicHome.vue'),
    meta: {
      alwaysAvailable: true,
      guestOnly: true
    }
  },
  {
    path: '/my-services',
    name: 'my-services',
    component: () => import('@/pages/MyServices/MyServices.vue'),
    meta: {
      alwaysAvailable: true,
      authRequired: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/Login/Login.vue"),
    meta: {
      alwaysAvailable: true,
    },
  },
  {
    path: "/placeholder",
    name: "placeholder",
    component: () => import("@/pages/Placeholder/Placeholder.vue"),
  },
  {
    path: "/profile",
    name: "profileFU",
    component: () => import("@/pages/Profile/ProfilePage.vue"),
    meta: {
      authRequired: true,
      alwaysAvailable: true
    }
  },
  {
    path: "/welcome",
    name: "welcome",
    component: pages.Welcome,
  },
  {
    path: "/dev",
    name: "dev",
    component: pages.Dev,
  },
  {
    path: "/finaluser",
    name: "finaluser",
    component: () => import("@/pages/Tabs/FinalUser.vue"),
  },
  {
    path: "/thankyoupage",
    name: "thankyoupage",
    component: () => import("@/pages/Tabs/ThankYouPage.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/profile-suspended",
    name: "profile-suspended",
    component: () => import("@/pages/ProfileSuspended/ProfileSuspended.vue"),
  },
  {
    path: "/subscribe",
    name: "subscribeFU",
    redirect: { name: "registration", params: { pageId: "register-finaluser" } },
  },
  /*
    Backward-compat: vecchi alias `/subscribe-<role>` rimossi in HDACC-261.
    Replicano 1:1 il mapping di useConfigurationTools.mapRoleToPageConfiguration
    (eliminato) come redirect statici dichiarativi verso i pageId reali — niente
    logica hardcoded nei componenti, solo una tabella di routing.
    DEVONO stare prima del catch-all `/:pageId(.+)` per avere priorità.
    Il caso default del vecchio mapping (`subscribe-<X>` verbatim) è già coperto
    dal catch-all, quindi non serve elencarlo qui.
  */
  {
    path: "/subscribe-administrator",
    redirect: { name: "registration", params: { pageId: "register-amministratore" } },
  },
  {
    path: "/subscribe-capo-hub",
    redirect: { name: "registration", params: { pageId: "register-capohub" } },
  },
  {
    path: "/subscribe-designer",
    redirect: { name: "registration", params: { pageId: "register-progettista" } },
  },
  {
    path: "/subscribe-professional",
    redirect: { name: "registration", params: { pageId: "register-professionista" } },
  },
  {
    path: "/subscribe-finaluser",
    redirect: { name: "registration", params: { pageId: "register-finaluser" } },
  },
  {
    path: "/subscribe-register",
    redirect: { name: "registration", params: { pageId: "register-pmi" } },
  },
  {
    path: "/subscribe-pmi",
    redirect: { name: "registration", params: { pageId: "register-pmi" } },
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("@/pages/NotFound/NotFound.vue"),
    meta: {
      alwaysAvailable: true,
    },
  },
  {
    path: "/:pageId(.+)",
    name: "registration",
    component: () => import("@/pages/Subscribe/Subscribe.vue"),
    meta: {
      alwaysAvailable: true,
    },
  },
];

export default routes;
